import { module } from 'stereomodularjs';

const COOKIE_NAME = 'ambra_popup_dismissed';
const SESSION_KEY = 'ambra_popup_dismissed';

function getCookie(name) {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	return match ? decodeURIComponent(match[2]) : null;
}

function setSessionCookie(name, value) {
	document.cookie =
		name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';
}

function hasAutoShownPopupThisSession() {
	try {
		if (sessionStorage.getItem(SESSION_KEY) === '1') return true;
	} catch (e) {
		/* private mode / storage blocked */
	}
	return Boolean(getCookie(COOKIE_NAME));
}

function markPopupAutoShownThisSession() {
	try {
		sessionStorage.setItem(SESSION_KEY, '1');
	} catch (e) {
		/* private mode */
	}
	setSessionCookie(COOKIE_NAME, '1');
}

export default class extends module {
	constructor(m) {
		super(m);
		this.dialog = document.querySelector('.js-modal');
		this.closeButton = document.querySelector('.js-modal-close');
		this.modalContent = document.querySelectorAll('[data-modal="content"]');
		this.popupPanel = this.el;
	}

	init() {
		if (!this.dialog || !this.popupPanel) return;
		if (hasAutoShownPopupThisSession()) return;

		this.modalContent.forEach((content) => content.classList.remove('is-active'));
		this.popupPanel.classList.add('is-active');
		this.dialog.showModal();
		markPopupAutoShownThisSession();

		this.boundCloseDialog = (e) => {
			if (e) e.stopPropagation();
			this.dialog.setAttribute('closing', '');
			this.dialog.addEventListener(
				'animationend',
				() => {
					this.dialog.removeAttribute('closing');
					this.dialog.close();
				},
				{ once: true }
			);
		};
		this.boundBackdrop = (e) => {
			if (e.target === this.dialog) this.boundCloseDialog(e);
		};

		this.closeButton.addEventListener('click', this.boundCloseDialog);
		this.dialog.addEventListener('click', this.boundBackdrop);
	}

	destroy() {
		if (this.dialog) {
			this.dialog.removeEventListener('click', this.boundBackdrop);
		}
		if (this.closeButton && this.boundCloseDialog) {
			this.closeButton.removeEventListener('click', this.boundCloseDialog);
		}
	}
}
